export enum ConstructCategoriesEnum {
    IMAGING = 'imaging',
    DEFAULT = 'default'
}

export enum MainDomainEnum {
    ALL_DOMAINS = 'All Domains',
    IMAGING = 'Imaging and Wearables',
}

export type Instrument = {
    name: string,
    count: number,
    description: string
}

export type Construct = {
    name: string,
    category: ConstructCategoriesEnum,
    instruments: Instrument[]
}
